<template>
    <div class="animated fadeIn ib-form">        
        <b-card>
            <div slot="header">
                Internal Budget Form (Pemecahan Master Budget yg Jumlah Produksi>1)
                <div class="card-header-actions">
                    <b-button variant="primary" v-if="saveEnabled" @click="save()"><i class="fa fa-save"></i> Save</b-button>
                    <b-button variant="secondary" @click="close()" > <i class="fa fa-close"></i> Close</b-button>
                </div>
            </div>
              <b-row>
                <b-col lg="8">
                    <b-row>
                        <b-col md="6">
                            <b-input-group>
                                <b-input-group-prepend><label>Master Budget No.</label></b-input-group-prepend>
                                <b-form-input v-model="model.nomor" readonly></b-form-input>
                                <b-input-group-append v-if="saveEnabled">
                                <b-btn text="Button" @click="lkuBudgetShow=true" >
                                    <i class="fa fa-search"></i>
                                </b-btn>
                                </b-input-group-append>
                            </b-input-group>
                        </b-col>
                        <b-col md="4">                            
                            <b-input-group>
                                <b-input-group-prepend><label>Master Budget Date</label></b-input-group-prepend>
                                <b-form-input v-model="model.tanggal" type="date"  disabled></b-form-input>                                        
                            </b-input-group>
                        </b-col>
                    </b-row >  
                    <b-row>
                        <b-col md="9">
                            <b-input-group >
                                <b-input-group-prepend><label>Budget Name</label></b-input-group-prepend>
                                <b-form-input v-model="model.uraian"  readonly></b-form-input>
                            </b-input-group>
                        </b-col>
                        <b-col md="3">
                            <b-form-checkbox :value="1" :unchecked-value="0" v-model="model.sales" disabled class="mt-1">Budget Sales/Project</b-form-checkbox>
                        </b-col>
                    </b-row>    

                    <b-row v-if="(model.sales=='1')">
                        <b-col md="7">
                            <b-input-group >
                                <b-input-group-prepend><label>Customer</label></b-input-group-prepend>
                                <b-form-input readonly v-model="model.custinfo" ></b-form-input>
                            </b-input-group>
                        </b-col>
                        <b-col md="5">
                            <b-input-group >
                                <b-input-group-prepend><label>Customer Order No.</label></b-input-group-prepend>
                                <b-form-input v-model="model.cust_po" placeholder="Customer Order No." readonly></b-form-input>
                            </b-input-group>
                        </b-col>
                    </b-row>    
                    <b-row>
                        <b-col md="4">
                            <b-input-group>
                                <b-input-group-prepend><label>Jumlah Produksi</label></b-input-group-prepend>
                                <b-form-input v-model="model.jmlproduksi" type="number" disabled ></b-form-input>
                                <b-input-group-prepend><span class="input-group-text">kali</span></b-input-group-prepend>
                            </b-input-group>
                        </b-col>
                        <b-col md="7">                            
                            <b-input-group>
                                <b-input-group-prepend><label>Nomor Produksi</label></b-input-group-prepend>
                                <b-form-input v-model="model.nomorproduksi" readonly placeholder="comma separated" ></b-form-input>
                            </b-input-group>
                        </b-col>
                    </b-row >  
                    <b-row>
                        <b-col md="7">
                            <b-input-group >
                                    <b-input-group-prepend><label >Periode Produksi</label></b-input-group-prepend>
                                    <b-form-input v-model="model.startdate" type="date" disabled></b-form-input>
                                    <b-input-group-prepend><span class="input-group-text">until</span></b-input-group-prepend>
                                    <b-form-input v-model="model.finishdate" type="date" disabled></b-form-input>
                            </b-input-group>
                        </b-col>
                        <b-col md="5">
                            <b-input-group>
                                <b-input-group-prepend><label>Lokasi Produksi</label></b-input-group-prepend>
                                <b-form-input v-model="model.lokasi" readonly></b-form-input>
                            </b-input-group>
                        </b-col>
                    </b-row>    

                </b-col>
                <b-col md="4">
                    <v-dim :model="model" :key="updateDimHdr"></v-dim>
                </b-col>
              </b-row>
            <hr>
              <b-row>
                <b-col lg="8">
                    <b-row>
                        <b-col md="4">
                            <b-input-group>
                                <b-input-group-prepend><label>Internat Budget No.</label></b-input-group-prepend>
                                <b-form-input v-model="model.nomorintern" v-b-tooltip.hover title="EMPTY for AUTO NUMBERING"></b-form-input>
                            </b-input-group>
                        </b-col>
                        <b-col md="8">
                            <b-input-group>
                                <b-input-group-prepend><label>Note/Remark</label></b-input-group-prepend>
                                <b-form-input v-model="model.remark" :disabled="!saveEnabled"></b-form-input>
                            </b-input-group>
                        </b-col>
                    </b-row >  
                    <b-row>
                        <b-col md="4">                            
                            <b-input-group>
                                <b-input-group-prepend><label>Jumlah Produksi</label></b-input-group-prepend>
                                <b-form-input v-model="model.ibjmlproduksi" type="number" disabled ></b-form-input>
                                <b-input-group-prepend><span class="input-group-text">kali{{produksike}}</span></b-input-group-prepend>
                            </b-input-group>
                        </b-col>
                        <b-col md="8">                            
                            <b-input-group>
                                <b-input-group-prepend><label>Produk/Eps. IB</label></b-input-group-prepend>
                                <b-form-input v-model="model.noprodintern" :state="!$v.model.noprodintern.$error" placeholder="comma separated" readonly></b-form-input>
                                <b-input-group-append v-if="saveEnabled">
                                <b-btn text="Button" @click="showFormProduksi=true" >
                                    <i class="fa fa-pencil"></i> edit
                                </b-btn>
                                </b-input-group-append>
                            </b-input-group>
                        </b-col>
                    </b-row>    
                </b-col>
                <b-col md="4">
                    <b-input-group >
                        <b-input-group-prepend><label >Start Requesition</label></b-input-group-prepend>
                        <b-form-input v-model="model.requstart" type="date"  :state="!$v.model.requstart.$error" :disabled="!saveEnabled"></b-form-input>
                    </b-input-group>
                    <b-input-group >
                        <b-input-group-prepend><label >End Requesition</label></b-input-group-prepend>
                        <b-form-input v-model="model.requend" type="date"  :state="!$v.model.requend.$error" :disabled="!saveEnabled"></b-form-input>
                    </b-input-group>
                </b-col>
              </b-row>
            <!-- CARA#1
            <div class="report-wraper">
                <table style="width: 99%;">
                    <thead>
                        <tr>
                            <th width="20px" rowspan="2">No.</th>
                            <th colspan="9" style="text-align:center">MASTER BUDGET</th>
                            <th width="120px" rowspan="2" style="text-align:center">RATA-RATA <br>PER PRODUKSI</th>
                            <th colspan="2" style="text-align:center">INTERNAL BUDGET</th>
                        </tr>
                        <tr>
                            <th >Description</th>
                            <th style="text-align:center" width="40px">Unit</th>
                            <th style="text-align:center" width="30px">Quantity</th>
                            <th style="text-align:center" width="50px">Repetition</th>
                            <th style="text-align:right" width="120px">Unit Price</th>
                            <th style="text-align:right" width="120px">Amount </th>
                            <th style="text-align:right" width="120px">Requested </th>
                            <th style="text-align:right" width="120px">Internal Budgeted (open)</th>
                            <th style="text-align:right" width="120px">Balance/Available</th>
                            <th style="text-align:right" width="140px">Amount </th>
                            <th style="text-align:right" width="100px"></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(row, idx) in budgetLines" :key="row.pjxbudgkey">
                            <td>{{idx+1}}</td>
                            <td>{{row.jccostname}}</td>
                            <td>{{row.unitsize}}</td>
                            <td>{{row.quantity}}</td>
                            <td style="text-align:right">{{row.repetit_qty}} {{row.repetit_nm}}</td>
                            <td style="text-align:right">{{row.unitprice |numFormat}}</td>
                            <td style="text-align:right">{{row.budgetamt |numFormat}}</td>
                            <td style="text-align:right">{{row.requested |numFormat}}</td>
                            <td style="text-align:right">{{row.ibopenamt |numFormat}}</td>
                            <td style="text-align:right">{{row.balanceamt |numFormat}}</td>
                            <td style="text-align:right">{{row.budgetrata2 |numFormat}}</td>
                            <td style="text-align:right">
                                <my-number v-if="(saveEnabled==true)" v-model="row.ibbudgetamt"  class="form-control text-right"  style="border:none; font-size: 0.8rem !important;" :precision="2" @change="calcPrice(row)"></my-number>
                                <span v-else>{{row.ibbudgetamt |numFormat}}</span>
                            </td>
                            <td style="text-align:right">
                                <div v-if="(row.ibbudgetamt>row.balanceamt)" style="background-color:#f86c6b;">           
                                        Melebihi Saldo 
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td class="subtotal"></td>
                            <td class="subtotal" colspan="5" style="text-align:right">Total Master Budget</td>
                            <td style="text-align:right" class="grdtotal">{{this.model.budgettotal|numFormat}}</td>
                            <td style="text-align:right" class="grdtotal">{{this.model.ttlrequested|numFormat}}</td>
                            <td style="text-align:right" class="grdtotal">{{this.model.ttlibopen|numFormat}}</td>
                            <td style="text-align:right" class="grdtotal">{{this.model.ttlbalance|numFormat}}</td>
                            <td style="text-align:right" class="grdtotal">{{this.model.ttlrata2|numFormat}}</td>
                            <td style="text-align:right" class="subtotal" >Total Intern.Budget</td>
                            <td style="text-align:right" class="grdtotal">{{this.model.ttlib|numFormat}}</td>
                        </tr>
                    </tbody>
                </table>
                
            </div>                   -->

            <div class="report-wraper">
                <table style="width: 99%;">
                    <thead>
                        <tr>
                            <th rowspan="2" style="max-width:20px; text-align:center; padding-left:2px; padding-right:2px;">No.</th>
                            <th colspan="8" style="text-align:center">MASTER BUDGET</th>
                            <th rowspan="2" style="width:120px; text-align:center">RATA-RATA <br>PER PRODUKSI</th>
                            <th colspan="2" style="text-align:center">INTERNAL BUDGET</th>
                        </tr>
                        <tr>
                            <!-- <th style="width:10px">No.</th> -->
                            <th style="min-width:500px">Description</th>
                            <th style="text-align:center; max-width:60px;">Unit</th>
                            <th style="text-align:center; max-width:70px;">QTY</th>
                            <th style="text-align:center; max-width:70px;">Repe-tition</th>
                            <th style="text-align:right" width="100px">Unit Price</th>
                            <th style="text-align:right" width="120px">Amount </th>
                            <th style="text-align:right" width="110px">Internal Budgeted</th>
                            <th style="text-align:right" width="100px">Balance / Available</th>
                            <th style="text-align:right" width="150px">Amount </th>
                            <th style="text-align:right" width="100px"></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(row, idx) in budgetLines" :key="row.pjxbudgkey">
                            <td style="max-width:20px; padding-left:2px; padding-right:0;">{{idx+1}}</td>
                            <td v-bind:class="{'bg-success': (row.ibbudgetamt) }">{{row.jccostname}} &nbsp; &nbsp; {{row.uraian}}</td>
                            <td>{{row.unitsize}}</td>
                            <td>{{row.quantity}}</td>
                            <td style="text-align:right;max-width:50px;">{{row.repetit_qty}} {{row.repetit_nm}}</td>
                            <td style="text-align:right">{{row.unitprice |numFormat}}</td>
                            <td style="text-align:right">{{row.budgetamt |numFormat}}</td>
                            <td style="text-align:right">{{row.ibB4amt |numFormat}}</td>
                            <td style="text-align:right">{{row.balanceamt |numFormat}}</td>
                            <td style="text-align:right">{{row.budgetrata2 |numFormat}}</td>
                            <td style="text-align:right">
                                <my-number v-if="(saveEnabled==true)" v-model="row.ibbudgetamt"  @change="calcPrice(row)" class="form-control text-right text-primary"  style="border:none; font-size: 0.8rem !important;" :precision="2"></my-number>
                                <span v-else>{{row.ibbudgetamt |numFormat}}</span>
                            </td>
                            <td style="text-align:right">
                                <div v-if="(row.ibbudgetamt>row.balanceamt)" style="background-color:#f86c6b;">           
                                        Melebihi Saldo 
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td class="subtotal"></td>
                            <td class="subtotal" colspan="5" style="text-align:right">Total Master Budget</td>
                            <td style="text-align:right" class="grdtotal">{{this.model.budgettotal|numFormat}}</td>
                            <td style="text-align:right" class="grdtotal">{{this.model.ttlibB4|numFormat}}</td>
                            <td style="text-align:right" class="grdtotal">{{this.model.ttlbalance|numFormat}}</td>
                            <td style="text-align:right" class="grdtotal">{{this.model.ttlrata2|numFormat}}</td>
                            <td style="text-align:right" class="subtotal" >Total Intern.Budget</td>
                            <td style="text-align:right" class="grdtotal text-primary">{{this.model.ttlib|numFormat}}</td>
                        </tr>
                    </tbody>
                </table>
                
            </div>                  

            <b-row class="justify-content-center mt-2">
                <b-button variant="primary" v-if="saveEnabled" @click="save()"><i class="fa fa-save"></i> Save</b-button>
                <b-button variant="secondary" @click="close()" > <i class="fa fa-close"></i> Close</b-button>
            </b-row>

        </b-card>
        <b-modal v-model="showFormProduksi" size="md"  title="Nomor Produksi (Episode/SerialNumber, ..)" :centered="true" ok-only>                
            <b-form-checkbox-group
                v-model="arrProduksi"
                :options="optionNomor"
                name="flavour-2a"
                stacked
                class="ml-3"
            ></b-form-checkbox-group>

        </b-modal> 
        <b-modal v-model="lkuBudgetShow" size="lg" :hide-footer="true" title="List of Master Budget" :centered="true">
            <lku-budgetproduksi @click="onSelectLkuBudget"></lku-budgetproduksi>
        </b-modal>        

    </div>
</template>
<style lang="scss">
   .ib-form{
    .input-group {
        padding-bottom:2px;
        .input-group-prepend {
            label {
                padding-top: 5px;
                padding-right: 5px;
                width: 130px;
            }
        }
    }
    .form-group {
        margin-bottom:2px;
        .input-group {
            padding-bottom:0;
        }
    }
    .row-details-form {
        .input-group-prepend {
            label {
                padding-top: 5px;
                padding-right: 5px;
                width: 90px;
            }
        }
        label {
        text-align: right !important;
        }
        legend {
        text-align: right !important;;
        }
    }

   }
</style>

<script>
import toastr from "mini-toastr";
import moment from 'moment';
import myNumber from "../../components/my-number";
import vDim from "../lookup/dimReadonly";
import lkuBudgetproduksi from "../lookup/lkuBudgetproduksi";
import budgetinternal from "../../apis/budgetinternal";
import dimension from "../../apis/dimension";
import { validationMixin } from "vuelidate";
import { required, requiredIf, numeric } from "vuelidate/lib/validators";
toastr.init();

export default {   
  components: { myNumber, vDim, lkuBudgetproduksi},
  mixins: [validationMixin],
  validations: {
        model: {
            pjxhdrkey: {required},
            requstart: { required },
            requend: { required },
            noprodintern: { required }
        },
  }, 
  data() {
    return {
        saveEnabled:true,
        lkuBudgetShow:false,
        updateDimHdr:false,
        uanguser: this.$store.state.user.matauang,
        model: {
            pjxhdrkey: '',
            requstart: '',
            requend: '',
            noprodintern: ''
        },
        budgetLines:[],
        showFormProduksi:false,
        produksike:'',
        nomorproduksi:'',
        arrProduksi:[],
        optionNomor:[]
    };
},
  computed: {
    dimension(){
      return this.$store.state.dimension;
    },
    invalidModel() {
      this.$v.model.$touch();
      return this.$v.model.$invalid;
    },
  },
  watch: {
      arrProduksi: function(newval) {
        const terurut=newval.slice().sort();
        this.model.noprodintern= terurut.join(",");
      }
  },
  created: async function(){
        this.routeAsal = localStorage.getItem('ib-menu') || "budget.internbudget";
        if (this.$route.params.ibudghdkey)  {
          toastr.info('Loading Budget Detail, please wait')
          try {
            const data = await budgetinternal.detail(this.$route.params);  
            const row = data[0][0];
            this.budgetLines = data[1];
            this.saveEnabled = (row.send2wf == 1 && row.isreviewed != 1) ? false : true;
            row.tanggal = row.tanggal ? moment(row.tanggal).format('YYYY-MM-DD') : '';
            row.startdate = row.startdate ? moment(row.startdate).format('YYYY-MM-DD') : '';
            row.finishdate = row.finishdate ? moment(row.finishdate).format('YYYY-MM-DD') : '';
            row.requstart = row.requstart ? moment(row.requstart).format('YYYY-MM-DD') : '';
            row.requend = row.requend ? moment(row.requend).format('YYYY-MM-DD') : '';
            row.noprodintern = row.noprodintern || '';
            if (this.saveEnabled) {
                this.arrProduksi= row.noprodintern.split(",");
                const arrNomor= row.nomorproduksi.split(",");
                const ibB4 = data[2]; 
                let arrNomorBooked=[];
                if ((ibB4) && (ibB4.noprodbooked)) {
                    arrNomorBooked= ibB4.noprodbooked.split(",");
                    this.produksike=`, yang ke-${ibB4.jmlib}`
                } 
                this.optionNomor=[];
                arrNomor.forEach(isi => {
                    const usedB4 = arrNomorBooked.find(nomor => nomor==isi);
                    const used = this.arrProduksi.find(nomor => nomor==isi);
                    if ((usedB4) && (!(used))) this.optionNomor.push( { text: isi, value: isi, disabled: true });
                    else this.optionNomor.push( { text: isi, value: isi });
                });
            }

            for (var key in row) {
                this.model[key] = row[key];
            }
            this.dimension.forEach((dim) => {
                if (this.model[dim.value]) {
                    this.model[`${dim.value}Info`] = this.model[dim.value] + ' | '+ this.model[`${dim.value}Txt`];
                }
            });            


            /* Saldo Master Budget(MB) bisa dihitung dalam 2 CARA, yaitu
            * CARA#1 yaitu dari realisasi Internal Budget(IB) yg sudah benar-benar direquest yg tercatat di MR,PO,Inventory, CashAdvance dan EC(ExpenseReimburs)  
            *           dan dari IB yg masih Open yg belum di Request
            * CARA#2 yaitu dari semua IB yg sudah pernah dibuat baik yg sudah direquest maupun yg belum, 
            *          Cara ini lebih berhati-hati, sehingga tidak ada kasus budget/anggaran tersisa dlm CARA#1 dihabis-habiskan untuk hal yg tidak diperlukan  
            */

//#region CARA#1           
            // const arrRequest = data[2];
            // const arrIbOpen = data[3];
            // let ttlrequested = 0;
            // let ttlibopen = 0;
            // let ttlbalance = 0;    
            // let ttlrata2 = 0;   
            // let ttlib = 0; 
            // this.budgetLines.forEach((line,idx) => {
            //     this.budgetLines[idx].budgetrata2=line.budgetamt/this.model.jmlproduksi;
            //     this.budgetLines[idx].totalreq = 0
            //     const requested = arrRequest.find(pjxbudgkey => pjxbudgkey==line.pjxbudgkey);
            //     if (requested) this.budgetLines[idx].totalreq = requested.totalreq;
                
            //     this.budgetLines[idx].ibopenamt = 0
            //     const ibOpen = arrIbOpen.find(ib => ib.pjxbudgkey==line.pjxbudgkey);
            //     if (ibOpen) this.budgetLines[idx].ibopenamt = ibOpen.ibopenamt;

            //     this.budgetLines[idx].balanceamt = line.budgetamt-line.totalreq-line.ibopenamt;
            //     ttlrequested += line.totalreq;
            //     ttlibopen += line.ibopenamt;
            //     ttlbalance += line.balanceamt;
            //     ttlrata2 += line.budgetrata2;
            //     ttlib += line.ibbudgetamt;
            // });
            // this.model.ttlbalance= ttlbalance;
            // this.model.ttlrequested = ttlrequested;
            // this.model.ttlibopen = ttlibopen;
            // this.model.ttlbalance = ttlbalance;    
            // this.model.ttlrata2 = ttlrata2;    
            // this.model.ttlib = ttlib;
//#endregion
//#region CARA#2          
            const arrIbB4 = data[4];
            let ttlibB4 = 0;
            let ttlbalance = 0;    
            let ttlrata2 = 0;   
            let ttlib = 0; 
            this.budgetLines.forEach((line,idx) => {
                this.budgetLines[idx].budgetrata2=line.budgetamt/this.model.jmlproduksi;
                
                this.budgetLines[idx].ibB4amt = 0
                const ibB4find = arrIbB4.find(ib => ib.pjxbudgkey==line.pjxbudgkey);
                if (ibB4find) {
                    this.budgetLines[idx].ibB4amt = ibB4find.ibB4amt;
                }
                this.budgetLines[idx].balanceamt = line.budgetamt-line.ibB4amt;
                ttlibB4 += line.ibB4amt;
                ttlbalance += line.balanceamt;
                ttlrata2 += line.budgetrata2;
                ttlib += line.ibbudgetamt;
            });
            this.model.ttlbalance= ttlbalance;
            this.model.ttlibB4 = ttlibB4;
            this.model.ttlbalance = ttlbalance;    
            this.model.ttlrata2 = ttlrata2;    
            this.model.ttlib = ttlib;
//#endregion

            // this.calcTotalDtlBudget();
            toastr.clear;
            this.updateDimHdr = !this.updateDimHdr;
          } catch (error) {
                console.log('error : ', error);
                toastr.error(JSON.stringify(error), "ERROR MESSAGE");                              
          }
        } else {
            this.model.ibtanggal  = moment().format('YYYY-MM-DD');            
            const dim = this.dimension.find(d => d.RelatedObj=='department');
            if (dim) {
                this.model[`${dim.value}`] = this.$store.state.user.departkd;
                this.model[`${dim.value}Txt`] = this.$store.state.user.departemen;
                this.model[`${dim.value}Info`] = this.$store.state.user.departkd + ' | ' + this.$store.state.user.departemen;
            }        
        }
        this.model.ibjmlproduksi=1;
  },
  methods: {
    save: async function () {
        if (!this.saveEnabled) {
            toastr.error('View mode cannot be Saved');
            return;
        }
        this.saveEnabled=false;
        if (this.invalidModel) {
            const invalidobj = {};
            for (var key in this.$v.model) {
            if (this.$v.model[key].$anyError) {
                if (this.$v.model[key].$anyError == true) invalidobj[key] = this.$v.model[key];
            }
            }
            console.log('validation model: ', this.model);
            console.log('validation field: ', invalidobj);
            toastr.error('Please fill the form correctly.', "ERROR MESSAGE");

            this.saveEnabled=true;
        } else {
            const requested = this.budgetLines.find(line => ((line.ibbudgetamt) && (line.ibbudgetamt>line.balanceamt)) );
            if (requested) {
                console.log(requested);
                toastr.error(`Budget Detail exceed the Balance Amount: ${requested.jccostname} ${requested.uraian}`);
                this.saveEnabled=true;
                return;
            }
            try {
                    const row = {};
                    row.ibudghdkey = this.model.ibudghdkey || '';
                    row.pjxhdrkey = this.model.pjxbudgkey || '';
                    row.nomorintern = this.model.nomorintern || '';
                    row.jmlproduksi = 1;
                    row.noprodintern = this.model.noprodintern || '';
                    row.pjxhdrkey = this.model.pjxhdrkey || '';
                    row.nomor = this.model.nomor || '';
                    row.uraian = this.model.uraian || '';
                    row.budgetname = this.model.budgetname || '';
                    row.remark = this.model.remark || '';
                    row.ibtanggal= this.model.ibtanggal ? moment(this.model.ibtanggal).format('YYYY-MM-DD') : undefined;
                    row.requstart= this.model.requstart ? moment(this.model.requstart).format('YYYY-MM-DD') : undefined;
                    row.requend = this.model.requend ? moment(this.model.requend).format('YYYY-MM-DD') : undefined;
                    row.lines = this.budgetLines.reduce((newArr, item) => {
                            newArr.push({
                                ibudgdtkey: item.ibudgdtkey ||'',
                                ibbudgetamt: item.ibbudgetamt ,           
                                pjxbudgkey : item.pjxbudgkey || '',
                                pjxhdrkey: item.pjxhdrkey,
                                ibquantity: Math.abs(item.ibquantity),
                                ibrepetit_qty: item.ibrepetit_qty
                            });
                        return newArr;
                    }, []);

                    if (this.model.ttlib !== 0) {
                        console.log('before save :', row);
                        const hasil= await budgetinternal.save(row);
                        toastr.success(`Success, Trx.Number ${hasil.nomorintern}`, "Save Budget",10000);
                        this.close();
                    } else {
                        toastr.error('Please fill at least 1(one) Budget Detail', 'ERROR MESSAGE');
                        this.saveEnabled=true;
                    }
            } catch (error) {
                console.log('error : ', error);
                if (error.sql) {
                    toastr.error(error.sql,'ERROR MESSAGE',10000);
                } else if (error.sqlMessage) {
                    toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
                } else if (error.message) {
                    toastr.error(error.message,'ERROR MESSAGE',10000);
                } else {
                    toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
                }   
                this.saveEnabled=true;            
            }

        }
    },
    onSelectLkuBudget: async function (_selected) {
        //    this.model=_selected;
            toastr.info('Loading Master Budget Detail, please wait')
            this.lkuBudgetShow=false;
            const data = await budgetinternal.mstrbudget({pjxhdrkey:_selected.pjxhdrkey});  
            this.budgetLines = data[0];
            const row = data[1][0];
            row.tanggal = row.tanggal ? moment(row.tanggal).format('YYYY-MM-DD') : '';
            row.startdate = row.startdate ? moment(row.startdate).format('YYYY-MM-DD') : '';
            row.finishdate = row.finishdate ? moment(row.finishdate).format('YYYY-MM-DD') : '';
            const arrNomor= row.nomorproduksi.split(",");
            for (var key in row) {
                this.model[key] = row[key];
            }
            this.model.budgetname= row.uraian;
            this.dimension.forEach((dim) => {
                if (row[dim.value]) {
                    this.model[`${dim.value}Info`] = row[dim.value] + ' | '+ row[`${dim.value}Txt`];
                }
            });
            this.updateDimHdr=!this.updateDimHdr;
            const ibB4 = await budgetinternal.ibbooked({pjxhdrkey:_selected.pjxhdrkey}); 
            // console.log('ibB4 : ', ibB4 ); 
            let arrNomorBooked=[];
            if ((ibB4) && (ibB4.noprodbooked)) {
                arrNomorBooked= ibB4.noprodbooked.split(",");
                this.produksike=`, yang ke-${ibB4.jmlib+1}`
            } else {
                this.produksike=',ke-1'
            }
            this.optionNomor=[];
            arrNomor.forEach(isi => {
                const used = arrNomorBooked.find(nomor => nomor.trim()==isi.trim());
                if (used) this.optionNomor.push( { text: isi, value: isi, disabled: true });
                else this.optionNomor.push( { text: isi, value: isi });
            });

            /* Saldo Master Budget(MB) bisa dihitung dalam 2 CARA, yaitu
            * CARA#1 yaitu dari realisasi Internal Budget(IB) yg sudah benar-benar direquest yg tercatat di MR,PO,Inventory, CashAdvance dan EC(ExpenseReimburs)  
            *           dan dari IB yg masih Open yg belum di Request
            * CARA#2 yaitu dari semua IB yg sudah pernah dibuat baik yg sudah direquest maupun yg belum, 
            *          Cara ini lebih berhati-hati, sehingga tidak ada kasus budget/anggaran tersisa dlm CARA#1 dihabis-habiskan untuk hal yg tidak diperlukan  
            */
//#region CARA#1
            // const arrIbOpen = data[4];
            // let ttlrequested = 0;
            // let ttlibopen = 0;
            // let ttlbalance = 0;    
            // let ttlrata2 = 0;    
            // this.budgetLines.forEach((line,idx) => {
            //     this.budgetLines[idx].budgetrata2=line.budgetamt/this.model.jmlproduksi;
            //     this.budgetLines[idx].ibquantity=0;
            //     this.budgetLines[idx].ibrepetit_qty='';
            //     this.budgetLines[idx].ibopenamt = 0
            //     const ibOpen = arrIbOpen.find(ib => ib.pjxbudgkey==line.pjxbudgkey);
            //     if (ibOpen) this.budgetLines[idx].ibopenamt = ibOpen.ibopenamt;
                
            //     this.budgetLines[idx].balanceamt = line.budgetamt-line.totalreq-line.ibopenamt;

            //     ttlrequested += line.totalreq;
            //     ttlibopen += line.ibopenamt;
            //     ttlbalance += line.balanceamt;
            //     ttlrata2 += line.budgetrata2;
            // });
            // this.model.ttlbalance= ttlbalance;
            // this.model.ttlrequested = ttlrequested;
            // this.model.ttlibopen = ttlibopen;
            // this.model.ttlbalance = ttlbalance;    
            // this.model.ttlrata2 = ttlrata2;    
            // this.model.ttlib = 0;
//#endregion
//#region CARA#2          
            const arrIbB4 = data[5].filter(ib => (ib.ibB4amt!=0));
            let ttlibB4 = 0;
            let ttlbalance = 0;    
            let ttlrata2 = 0;   
            this.budgetLines.forEach((line,idx) => {
                this.budgetLines[idx].budgetrata2=line.budgetamt/this.model.jmlproduksi;

                this.budgetLines[idx].ibB4amt = 0
                const ibB4find = arrIbB4.find(ib => ib.pjxbudgkey==line.pjxbudgkey);
                if (ibB4find) {
                    this.budgetLines[idx].ibB4amt = ibB4find.ibB4amt;
                }
                
                this.budgetLines[idx].balanceamt = line.budgetamt-line.ibB4amt;
                ttlibB4 += line.ibB4amt;
                ttlbalance += line.balanceamt;
                ttlrata2 += line.budgetrata2;
            });
            this.model.ttlbalance= ttlbalance;
            this.model.ttlibB4 = ttlibB4;
            this.model.ttlbalance = ttlbalance;    
            this.model.ttlrata2 = ttlrata2;    
            this.model.ttlib = 0;
//#endregion
        toastr.clear;
        // this.calcTotalDtlBudget();
    },
    calcPrice : function (budgetLine) {
        this.calcTotalDtlBudget();
        // this.$forceUpdate();
    },
    calcTotalDtlBudget: function () {
        let ttlamtib = 0;
        this.budgetLines.forEach((trx)=> {
            ttlamtib += (trx.ibbudgetamt || 0);
        });
        this.model.ttlib = ttlamtib;
    },
    close(){
      if (this.routeAsal) {
          router.push({name:this.routeAsal});    
      } else {
          router.push({path:"home"});    
      }
    }
  }
};
</script>
